import { Check, User, CalendarCheck } from "lucide-react";
import { motion } from "framer-motion";

const STEPS = [
  { label: "Your Details", icon: User, color: "from-red-500 to-orange-500" },
  { label: "Book a Time", icon: CalendarCheck, color: "from-emerald-500 to-teal-500" },
];

const QuickStepIndicator = ({ currentStep }: { currentStep: number }) => {
  return (
    <div className="flex items-center justify-center gap-0 w-full max-w-sm mx-auto py-3 sm:py-6 px-4">
      {STEPS.map((step, idx) => {
        const isCompleted = idx < currentStep;
        const isActive = idx === currentStep;
        const Icon = step.icon;

        return (
          <div key={idx} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center gap-1.5 relative">
              <motion.div
                initial={false}
                animate={{ scale: isActive ? 1.1 : 1 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
                className={`relative flex items-center justify-center w-9 h-9 sm:w-11 sm:h-11 rounded-full border-2 transition-all duration-300 ${
                  isCompleted
                    ? "border-emerald-500 bg-emerald-500 text-white shadow-lg shadow-emerald-500/30"
                    : isActive
                    ? `border-transparent bg-gradient-to-br ${step.color} text-white shadow-lg`
                    : "border-slate-200 bg-white text-slate-400"
                }`}
              >
                {isCompleted ? (
                  <Check className="h-5 w-5" strokeWidth={3} />
                ) : (
                  <Icon className="h-5 w-5" />
                )}
                {isActive && (
                  <motion.div
                    layoutId="quick-step-ring"
                    className={`absolute -inset-1 rounded-full border-2 border-dashed opacity-40 ${
                      idx === 0 ? "border-red-400" : "border-emerald-400"
                    }`}
                    transition={{ type: "spring", stiffness: 200, damping: 25 }}
                  />
                )}
              </motion.div>
              <span
                className={`text-[10px] sm:text-[11px] font-semibold uppercase tracking-wider text-center max-w-[70px] sm:max-w-none sm:whitespace-nowrap leading-tight transition-colors duration-300 ${
                  isActive
                    ? "text-slate-800"
                    : isCompleted
                    ? "text-emerald-600"
                    : "text-slate-400"
                }`}
              >
                {step.label}
              </span>
            </div>

            {idx < STEPS.length - 1 && (
              <div className="flex-1 mx-2 h-0.5 rounded-full bg-slate-200 relative overflow-hidden mt-[-18px]">
                <motion.div
                  initial={{ scaleX: 0 }}
                  animate={{ scaleX: isCompleted ? 1 : 0 }}
                  transition={{ duration: 0.4, ease: "easeOut" }}
                  className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-emerald-500 origin-left rounded-full"
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default QuickStepIndicator;
